import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
	// 导航菜单
	'小学':'小学',
	'初中':'初中',
	'国际高中':'国际高中',
	'长城书院':'长城书院',
	'来华':'来华',
	'nav_小学':'小学',
	'nav_初中':'初中',
	'nav_国际高中':'国际高中',
	'nav_长城书院':'长城书院',
	'nav_来华':'来华',
	'探索':'探索',
	'招生':'招生',
	'新闻':'新闻',
	'我们的愿景':'我们的愿景',
	'我们的历史':'我们的历史',
	'VR探校':'VR探校',
	'校园设施设备':'校园设施设备',
	'1V1预约看校':'1V1预约看校',
	'学校收费标准':'学校收费标准',
	'退费政策':'退费政策',
	'招生问答':'招生问答',
	'核心课程':'核心课程',
	'IB-PBL融合课程':'IB-PBL融合课程',
	'素质拓展体系':'素质拓展体系',
	'行走的课堂':'行走的课堂',
	'多元升学通道':'多元升学通道',
	'黄金师资配置':'黄金师资配置',
	'IP国际班':'IP国际班',
	'升学报告':'升学报告',
	'国内课程':'国内课程',
	'双轨互转':'双轨互转',
	'双语赋能计划':'双语赋能计划',
	'资质与保障':'资质与保障',
	'中文与学术':'中文与学术',
	'成功案例':'成功案例',
	'百万':'百万',
	// 尾部
	'扫码关注我们的公众号':'扫码关注我们的公众号',
	'北京中加学校':'北京中加学校',
	'北京通州华仁学校':'北京通州华仁学校',
	'扫码关注视频号':'扫码关注视频号',
	'扫码在小红书里找到我们':'扫码在小红书里找到我们',
	'电话':'电话：010 89598885',
	'地址':'地址：北京市通州区丛林庄园',
	'版权':' © 2024 北京中加学校 . All Rights Reserved.',
	'隐私政策':'隐私政策',
	'APP下载':'APP下载（安卓测试版）',
	// 首页
	'left':'北京中加学校\nBCCSC',
	'right':'北京通州华仁学校\nBCS',
	'给孩子未来图景':'给孩子未来图景',
	'构建共融世界的教育平台':'构建共融世界的教育平台',
	'第一所中外合作办学学校':'第一所中外合作办学学校',
	'建校 28 年':'建校 29 年',
	'毕业生遍布 32+ 国家':'毕业生遍布 32+ 国家',
	'1:7 师生比例':'1:7 师生比例',
	'300万元人民币奖学金':'1400万元人民币奖学金',
	'新闻':'新闻',
	'记录学校、学生与老师的日常活动':'记录学校、学生与老师的日常活动',
	'让大家对BCCSC与BCS拥有完整的了解':'让大家对BCCSC与BCS拥有完整的了解',
	'喜欢学校、爱上课程活动、欣赏孩子们':'喜欢学校、爱上课程活动、欣赏孩子们',
	// 关于我们
	'关于我们':'关于我们',
	'下载我们的招生简章':'下载我们的招生简章',
	'手机号':'手机号',
	'提交':'提交',
	'请输入手机号':'请输入手机号',
	'关注&探索':'关注&探索',
	'家长平台':'家长平台',
	'学生系统':'学生系统',
	'STAFF':'STAFF',
	'招生咨询':'招生咨询',
	'我们会认真评估每一份申请。':'我们会认真评估每一份申请。',
	'在接下来的几个月中，我们期待能更好地了解申请人及其家庭。':'在接下来的几个月中，我们期待能更好地了解申请人及其家庭。',
	'立即咨询':'立即咨询',
	// 小学
	'为未来奠基':'为未来奠基',
	'让梦想起航':'让梦想起航',
	'elementaryschool_jeishao':'小学阶段，依靠小班建制优势，我们给予核心课程更大的延伸与落实空间，\n学生充分参与知识的探究过程，建立扎实的学术基础。\n我们鼓励学生积极参与知识的探索过程，培养独立思考和解决问题的能力。',
	'elementaryschool_jeishao4':'全人教育，塑造未来世界公民',
	'elementaryschool_jeishao5':'我们秉承全人教育理念，致力于培养',
	'elementaryschool_jeishao6':'德智体美劳全面发展的未来世界公民。',
	'elementaryschool_jeishao7':'小学部精心打造艺术、运动、科学、心理等多维度培育空间，\n帮助学生在小学阶段构建多元知识体系，塑造健全人格，树立正确价值观和积极的人生态度。',
	'践行”4D成长模型”，系统培育：':'践行”4D成长模型”，系统培育：',
	'认知维度':'认知维度',
	'建立学科知识网络与批判性思维':'建立学科知识网络与批判性思维',
	'品格维度':'品格维度',
	'通过美德课程塑造责任意识与公民素养':'通过美德课程塑造责任意识与公民素养',
	'创造维度':'创造维度',
	'设立STEAM创新工坊与艺术创想空间':'设立STEAM创新工坊与艺术创想空间',
	'社会维度':'社会维度',
	'设计公益服务、游学与田野调查学习项目':'设计公益服务、游学与田野调查学习项目',
	'夯实基础，放眼世界':'夯实基础，放眼世界',
	'国家课程深度开发':'国家课程深度开发',
	'我们严格遵循国家课程标准，拓展学科知识的广度和深度：':'我们严格遵循国家课程标准，拓展学科知识的广度和深度：',
	'语文学科融入经典诵读与创意写作':'语文学科融入经典诵读与创意写作',
	'数学课程开发“生活建模”专题，年均完成12个真实场景项目':'数学课程开发“生活建模”专题，年均完成12个真实场景项目',
	'沉浸式双语教学':'沉浸式双语教学',
	'独创“双语浸润矩阵”周均9节外教课程，覆盖：':'独创“双语浸润矩阵”周均9节外教课程，覆盖：',
	'学术英语（剑桥少儿英语体系）':'学术英语（剑桥少儿英语体系）',
	'体育（国际体能训练标准）':'体育（国际体能训练标准）',
	'艺术（跨文化审美课程）':'艺术（跨文化审美课程）',
	'采用国际文凭项目方法论，构建六阶段探究闭环':'采用国际文凭项目方法论，构建六阶段探究闭环',
	'每学期开展2个跨学科主题项目（如「城市生态实验室」「文化遗产守护者」）':'每学期开展2个跨学科主题项目（如「城市生态实验室」「文化遗产守护者」）',
	'问题界定':'问题界定',
	'信息调研':'信息调研',
	'方案设计':'方案设计',
	'实践验证':'实践验证',
	'成果展示':'成果展示',
	'反思迭代 探究循环':'反思迭代 探究循环',
	'建立“三维发展课程群”':'建立“三维发展课程群”',
	'配备「课程选择导航系统」，支持学生自主构建个性化课':'配备「课程选择导航系统」，支持学生自主构建个性化课',
	'国际竞赛与测评体系':'国际竞赛与测评体系',
	'每年小学部的学生们，总会出现在各个国际赛事的竞技现场，':'每年小学部的学生们，总会出现在各个国际赛事的竞技现场，',
	'展现卓越与创造力，覆盖数学、编程、思维等多个学科。':'展现卓越与创造力，覆盖数学、编程、思维等多个学科。',
	'澳大利亚AMC数学竞赛':'澳大利亚AMC数学竞赛',
	'澳大利亚信息数学竞赛':'澳大利亚信息数学竞赛',
	'英国海狸计算机思维挑战赛':'英国海狸计算机思维挑战赛',
	'牛津运算思维挑战赛':'牛津运算思维挑战赛',
	// 初中
	'多元发展':'多元发展',
	'筑梦未来':'筑梦未来',
	'middleschool_jeishao':'初中阶段，我们在全面开设国家课程的基础上，\n致力于为学生提供多元优质的传统文化与国际化课程选择。\n我们相信，每个学生都拥有独特的天赋和潜能，因此在双语教学的框架下，\n我们以优质的教学满足每个学生不同的兴趣、能力与需求，\n帮助他们实现国家课程升学目标、国际体系学术基础。',
	'双轨课程体系':'双轨课程体系',
	'构建「国家课程精修+国际课程预研」双通道培养模型':'构建「国家课程精修+国际课程预研」双通道培养模型',
	'国家课程深化':'国家课程深化',
	'实施“学科+”改革：语文/历史融入戏剧工坊，让文学与历史成为沉浸式的个人体验':'实施“学科+”改革：语文/历史融入戏剧工坊，让文学与历史成为沉浸式的个人体验',
	'数学/物理推行“概念迁移训练”，开发12个跨学科应用模块':'数学/物理推行“概念迁移训练”，开发12个跨学科应用模块',
	'国际课程衔接':'国际课程衔接',
	'开设三大预备课程群：':'开设三大预备课程群：',
	'│ 英联邦方向 │ GCSE先修课程（数学/科学双语授课）':'│ 英联邦方向 │ GCSE先修课程（数学/科学双语授课）',
	'│ 北美方向 │ OSSD学分课程（外教全英文授课）':'│ 北美方向 │ OSSD学分课程（外教全英文授课）',
	'│ 语言专项 │ 雅思系统培训（CEFR B2达标率92%）':'│ 语言专项 │ 雅思系统培训（CEFR B2达标率92%）',
	'中外师资团队打造”三维语言发展矩阵”':'中外师资团队打造”三维语言发展矩阵”',
	'配备语言成长档案，追踪CEFR与IELTS指标双轨进步':'配备语言成长档案，追踪CEFR与IELTS指标双轨进步',
	'学术语言层':'学术语言层',
	'学科双语渗透率达60%课程':'学科双语渗透率达60%课程',
	'文化沟通层':'文化沟通层',
	'每周4课时外教人文研讨课':'每周4课时外教人文研讨课',
	'实践应用层':'实践应用层',
	'跨国课题合作（年均3项）':'跨国课题合作（年均3项）',
	'人文特色：激发潜能，全面发展':'人文特色：激发潜能，全面发展',
	'我们提供丰富多彩的活动机会':'我们提供丰富多彩的活动机会',
	'行走的课堂：真实的世界体验':'行走的课堂：真实的世界体验',
	'我们坚信，真正的学习不仅仅局限于课堂。':'我们坚信，真正的学习不仅仅局限于课堂。',
	'因此，我们为学生提供大量的游学、社会实践机会':'因此，我们为学生提供大量的游学、社会实践机会',
	'田野调查':'田野调查',
	'让学生走出校园，接触社会，接纳新鲜文化，建立更为扎实的认知与价值观。':'让学生走出校园，接触社会，接纳新鲜文化，建立更为扎实的认知与价值观。',
	'国际交流':'国际交流',
	"参与爱丁堡公爵国际奖（The Duke of Edinburgh's International Award）素质挑战，在户外探索、 公益服务、领袖精神等方面取得成就；与来自世界各地的学生交流互动，开拓国际视野。":"参与爱丁堡公爵国际奖（The Duke of Edinburgh's International Award）素质挑战，在户外探索、 公益服务、领袖精神等方面取得成就；与来自世界各地的学生交流互动，开拓国际视野。",
	'护航未来，成就梦想':'护航未来，成就梦想',
	'我们提供多元化的升学指导课程，为学生在初中阶段这个关键选择期保驾护航。无论是国内升学还是国际升学，我们都能为学生和家庭提供专业的指导和支持，帮助他们找到最适合自己的发展方向，成就梦想。':'我们提供多元化的升学指导课程，为学生在初中阶段这个关键选择期保驾护航。无论是国内升学还是国际升学，我们都能为学生和家庭提供专业的指导和支持，帮助他们找到最适合自己的发展方向，成就梦想。',
	'国内':'国内',
	'北美':'北美',
	'英联邦':'英联邦',
	'小语种':'小语种',
	'艺术':'艺术',
	'体育':'体育',
	'青春礼2025 · 我们的十四岁':'青春礼2025 · 我们的十四岁',
	// 国际高中
	'对接全球知识视野':'对接全球知识视野',
	'代表东方文化力量':'代表东方文化力量',
	'highschool_jeishao':'1997年3月26日，北京中加学校在人民大会堂成立，\n 是第一所实施普通高中教育的中外合作学校，\n我校构建独特的「双轨三认证」培养模式\n为每个学生建立加拿大学籍，设计专属升学规划\n同时，我们拥有HKDSE课程 ，提供家庭更为多元方向选择',
	'中国普通高中文凭':'中国普通高中文凭',
	'加拿大安省高中文凭(OSSD)':'加拿大安省高中文凭(OSSD)',
	'AP课程认证资质（美国大学理事会代码：694222）':'AP课程认证资质（美国大学理事会代码：694222）',
	'28年教育成就':'29年教育成就',
	'全球升学率100%':'全球升学率100%',
	'25届毕业生100%进入QS/U.S.News 世界TOP100院校':'26届毕业生100%进入QS/U.S.News 世界TOP100院校',
	'奖学金收割机':'奖学金收割机',
	'25届87%以上学生获得奖学金，2023届人均获奖学金23.6万元，总额突破3800万元':'26届90%以上学生获得奖学金，2026届人均获奖学金28.2万元，总额突破1400万元',
	'人才培养范式':'人才培养范式',
	'63%毕业生任职世界500强企业，22%创立跨境创新项目':'63%毕业生任职世界500强企业，22%创立跨境创新项目',
	'文化传承标杆':'文化传承标杆',
	'非遗研究项目获联合国教科文组织青年教育奖':'非遗研究项目获联合国教科文组织青年教育奖',
	'国际教育梦之队':'国际教育梦之队',
	'国际教育梦之队_des':'外籍教师40%\nIB/AP考官占比35%\n硕士以上学历82%',
	'认证体系':'认证体系',
	'认证体系_des':'100%持两国教师资格证\n100%通过AP Capstone导师认证',
	'教研创新':'教研创新',
	'教研创新_des':'中外教师联合研发12套跨文化教材\n（获加拿大教育部认证）',
	'IP国际班_des':'中加IP国际班通过 “权威认证+丰富课程+深度融合” 的三维模式，\n构建了⼀条兼顾学术严谨性与升学灵活性的路径。\n对于寻求稳妥过渡到海外名校，且希望⾼效利⽤⾼中资源的学⽣，该项⽬具备显著竞争⼒。',
	'合规可靠':'合规可靠',
	'官方背书降低课程风险':'官方背书降低课程风险',
	'资源集约':'资源集约',
	'校内一站式解决标化、竞赛、语言培训，减少外部依赖。':'校内一站式解决标化、竞赛、语言培训，减少外部依赖。',
	'实践应用层':'实践应用层',
	'课程设计满足多国申请需求，适配不同留学规划。':'课程设计满足多国申请需求，适配不同留学规划。',
	'xiaoxue_shangmian':'国际班以OSSD（加拿大安大略省高中文凭）为核心，结合AP（美国大学先修课程）及ACT（美国大学入学考试）备考课程',
	'xiaoxue_xiamian':'同时GAC（全球评估证书课程），形成多元化的国际课程体系。目标直击美、英、加、澳等主流留学国家的顶尖大学申请。',
	'2024升学报告':'2026升学报告',
	'2024升学报告_des':'截至 2026 年 7 月初，我校 2026 届高三国际班毕业生申请海内外高校，累计收获来自加拿大、英国、美国、\n澳大利亚、新西兰、瑞典、韩国、日本、匈牙利 9 个国家近 57 所大学的 388 份录取通知书，奖学金总额高达 1400 万元人民币。\n所有录取院校均为世界排名前 100 名校；加拿大方向录取全部来自加拿大前十高校。\n值得欣喜的是，多伦多大学、英属哥伦比亚大学、麦吉尔大学这三所全球前 50。加拿大顶尖三校均向我校学生发放录取；\n澳大利亚申请学子 100% 收获墨尔本大学、悉尼大学、新南威尔士大学录取，三校均为澳洲八大、\n世界百强名校。 祝贺北京中加学校 2026 届全体毕业生，本届升学再创佳绩！',
	'个性化支持系统':'个性化支持系统',
	'1:4师生比 | 动态分层走班制 | 持牌规划师1v1护航':'1:4师生比 | 动态分层走班制 | 持牌规划师1v1护航',
	'全时域支持：教师驻校制（日均12小时学术支持）':'全时域支持：教师驻校制（日均12小时学术支持）',
	'全球视野背景提升':'全球视野背景提升',
	'swiper_miaoshu':'学部注重课外活动课程与爱丁堡国际奖、国际课程社区服务学分整合，实现“一课多效”。\n学部遴选助力学生名校录取的优质的背景提升项目，迅速提升学生软实力，助力学生国内外大学申请。',
	'highschool_des_tit_com':'我校始终秉持国际化育人理念，构建多层次海外研学体系。\n每学年组织学生开展为期一学期的加拿大深度研学项目，\n依托学分互认机制，通过沉浸式插班学习，深度融入当地教育生态。\n此外，学部每学期精心策划覆盖全球多元文化的研学活动矩阵，\n涵盖国际学术会议、青年发展论坛、寒暑假跨国研学营等，\n为学生定制个性化国际交流方案，\n助力学子在跨文化对话中提升全球胜任力，擘画具有国际视野的成长蓝图。',
	// 长城书院
	'选择长城书院':'选择长城书院',
	'成就高考梦想':'成就高考梦想',
	'changchengshuyuan_jianjei':'2026年高考，北京中加学校最高分：603分！\n斩获通州区民办学校唯一600分以上佳绩！\n学生本科上线率：80.9%，其中一本上线率：33.3%\n本届学子对比中考入学时的原始区排名，平均提升13,376名，实现了学业的全面跨越与成长：\n梁同学：排名提升47,652名，增幅全校第一；\n刘同学：排名提升44,837名，实现从基础薄弱到高分的华丽转身；\n赵同学：排名提升35,892名，强势逆袭；',
	'高考班课程以国内课程为主体':'高考班课程以国内课程为主体',
	'分基础类、拓展类、提升类三个类别':'分基础类、拓展类、提升类三个类别',
	'小班教学个性指导':'小班教学 个性指导',
	'分层教学':'分层教学',
	'多元评价':'多元评价',
	'个性化发展':'个性化发展',
	'小班教学个性指导_com':'平均师生配比为 1:6，每班学生人数不超过 30 人，\n保障教学质量的同时，充分调动学生的主观能动性，深化师生交流，确保学生的个性化指导。\n教学内容科学，衔接初中、高中学习内容，强化学生知识结构，注重跨学科、跨文化全人教育。\n难度方面通过分层、分类、一生一案，确保适合不同层次学生水平。',
	'小班教学个性指导_com_bg':'五测成绩随时告知家长（课堂测、周测、月考、期中统考、期末统考），便于家长了解学生学业情况，免费安排周末及假期的辅导，免除家长后顾之忧。',
	'专业教研保障质量':'专业教研 保障质量',
	'教学区':'教学区',
	'生活区':'生活区',
	'就餐区':'就餐区',
	'专业教研保障质量_com':'教学围绕西城区、通州区教研，考试及阅卷统一参加区统考。\n强化必修课程，突出选择性必修及选修课程，对标高考。\n以市区统考为基础，建立完善学生学业的阶梯评价体系和激励机制，\n从学生、学科、班主任三方面定期开展质ᰁ分析，不断提高教育教学质。',
	'专业教研保障质量_com_bg':'引进学科网、中国教研网、北京教育学会等优质资源，助力学生冲刺高考。',
	'双轨互转多元出口':'双轨互转 多元出口',
	'双轨互转多元出口_com':'各年级学生在每学年结束后，经学校评估后都有机会转轨，满足家长对孩子在不同阶段成长及发展的多元需求和变化。\n另外，心理健康课程融入课表，由国家认证心理咨询师任教，\n每周通过心理健康课程、心理活动呵护学生心灵成长，\n帮助学生探索内在自我和他人关系，提升认知情绪、情感感知和人际关系管理。',
	'高考':'高考',
	'艺考':'艺考',
	'中外合作大学':'中外合作大学',
	'留学':'留学',
	'免费复读':'免费复读',
	'gwacademy_wenzijeis':'课程设计基于国家课程标准，注重全面知识体系建设。\n学生在高三可以选择高考、艺考、中外合作大学、留学、免费复读（符合学校规定情况下高三年级一次）五个路径。',
	'gwacademy_wenzijeis1':'生涯规划课程融入课表，由学校指导办 20 多年升学指导经验教师任教，\n全程一对一指导学生大学专业申请、奖学金申请、选课、文书准备、签证办理等工作，\n鼓励学生在教师指导下，自主规划升学路径，无需家长联系中介，节省家庭经济成本。\n对高考班学生进行学考选科、高考六选三等指导。\n100 多门选修课程、研学课程、爱丁堡活动课程每周固定时间开展。\n学生评价重视过程性评价、终结性评价、增值评价相结合，满足学生多元发展需求，\n兼顾扎实的学术基础与学生的个性成长，提高学生国内外名校录取竞争力。',
	'专任教师':'专任教师',
	'高级职称':'高级职称',
	'中级职称':'中级职称',
	'特级教师':'特级教师',
	'高级教师':'高级教师',
	'huangbeijing_com':'高中部国内方向课程，现有专任教师 44 人、高级职称 5 人、中级职称 14 人，包括特级教师 1 人、高级教师 12 人。\n本科以上学历 100%，其中硕士 38%。学部聘请西城区、通州区的教研骨干作为学校学术委员会核心专家，全程指导高考班教学及考试。',
	'双语赋能计划':'双语赋能计划',
	'双语赋能计划_des':'学校除关注学生学业成绩外，更关心学生综合素养提升，这既是中加教育的鲜明特色，\n也是学生全面发展的必备要件、培养人才的重要渠道，也是对研究性学习、社区服务、社会实践等大德育课程最好的补充。\n学校确定“活动课程体系”，将专题教育活动课程化，形成专题教育课程（每月开展）。',
	'爱国主义教育课程':'爱国主义教育课程',
	'国防教育课程':'国防教育课程',
	'传统文化课程':'传统文化课程',
	'表演课程':'表演课程',
	'校庆活动':'校庆活动',
	'文化节':'文化节',
	'科技节':'科技节',
	'运动会':'运动会',
	// 来华
	'让世界融入我们的语言、文化与学术':'让世界融入我们的语言、文化与学术',
	'资质与保障':'资质与保障',
	'资质与保障_com':'北京中加学校BCCSC，是第一所中外合作办学普通高中学历教育学校。我们拥有完整的资质和保障流程，为世界范围内的适龄学生，提供基础教育学习机会。无论家庭对孩子的未来规划在中国，还是其他国家地区，北京中加学校都是非常理想的选择。',
	'中文与学术':'中文与学术',
	'中文与学术_com':'世界范围的中文学习，已跟随中国与世界的交流步伐，形成较为强势的文化输出态势，我们在语言与文化的熔融课程，让学生在未来更具竞争优势。在北京中加学校，学生还会学习到全面的国际学术课程，无论OSSD加拿大高中课程，还是AP、ACT美国课程，均提供给学生申请世界名校的巨大舞台。',
	'成功案例':'成功案例',
	'成功案例_com':'目前，学校拥有来自北美、欧洲、亚洲等区域200余人次来华学生，其中韩国方向，拥有独立管理体系，拥有专职管理教师与学位。',
	// 新闻
	'关注我们':'关注我们',
	'了解更多':'了解更多',
	// 探索
	'我们的愿景':'我们的愿景',
	'为学生创设共荣世界教育平台，':'为学生创设共荣世界教育平台，',
	'是':'是',
	'北京中加学校（BCCSC）':'北京中加学校（BCCSC）',
	'与':'与',
	'北京通州华仁学校（BCS）':'北京通州华仁学校（BCS）',
	'近30年来致力推动的愿景。':'近30年来致力推动的愿景。',
	'学校建立融合双语优势课程系统，立足中国恢弘文化积淀，让孩子们在这里逐步成长为':'学校建立融合双语优势课程系统，立足中国恢弘文化积淀，让孩子们在这里逐步成长为',
	'的全球人才。':'的全球人才。',
	'学校的公民教育，着力学生':'学校的公民教育，着力学生',
	'沟通多元':'沟通多元',
	'生存独立':'生存独立',
	'文化自信':'文化自信',
	'等三个方向的培养，护航孩子基础教育全阶段的身心灵健康发展。':'等三个方向的培养，护航孩子基础教育全阶段的身心灵健康发展。',
	'我们的历史':'我们的历史',
	'1997 北京中加学校在人民大会堂成立':'1997 北京中加学校在人民大会堂成立',
	'1997 学校被正式吸纳为联合国<br>教科文组织北京俱乐部协会成员校':'1997 学校被正式吸纳为联合国<br>教科文组织北京俱乐部协会成员校',
	'2001 北京中加学校开设全国范围分校20余所':'2001 北京中加学校开设全国范围分校20余所',
	'2004 成为北京市第一批通过国家教育部<br>复核验收合格的中外合作办学机构':'2004 成为北京市第一批通过国家教育部<br>复核验收合格的中外合作办学机构',
	'2008 学校被审批通过的第一批北京市普通高中<br>自主安排新课程实验校':'2008 学校被审批通过的第一批北京市普通高中<br>自主安排新课程实验校',
	'2013 北京通州华仁学校成立':'2013 北京通州华仁学校成立',
	'2013 成为中国大陆地区第一所圆方成员校':'2013 成为中国大陆地区第一所圆方成员校',
	'2014 学校获得“最具办学特色的国际学校”、“2014全国环境教育示范学校”及“留学杂志榜推荐的国际学校”等称号':'2014 学校获得“最具办学特色的国际学校”、“2014全国环境教育示范学校”及“留学杂志榜推荐的国际学校”等称号',
	'基础设施':'基础设施',
	'功能教室':'功能教室',
	'功能教室_com':'学校拥有物理、化学、生物等标准实验室6间，计算机教室4间，钢琴教室12间，舞蹈教室2间，戏剧教室2间，美术教室3间，古琴教室1间',
	'报告厅':'报告厅',
	'报告厅_com':'学校扩容改建开放剧场形态报告厅，可容纳300人，拥有最新的灯光音响系统与大屏幕放映系统，可用于教学研讨、学生汇演、戏剧、音乐会等形式的活动与演出。',
	'篮球馆':'篮球馆',
	'篮球馆_com':'室内篮球馆采用CBA标准双层龙骨运动地板，及配套设施设备，可进行标准的篮球赛事，同时管所兼容羽毛球场地标准，利用可收卷赛事级地胶，迅速转换场馆功能。',
	'室外运动空间':'室外运动空间',
	'室外运动空间_com':'校园操场完成400米跑道标准操场改造升级，拥有可通过FIFA认证草皮的标准足球场地。 \n 同时我们升级了三块硅PU材质室外篮球场地，独特的奥运紫，增加运动乐趣。\n同样升级的还有两块标准室外网球场地。',
	'学生宿舍':'学生宿舍',
	'学生宿舍_com':'学校宿舍，可容纳6700人住宿需求，宿舍分为4人间与2人间，每个楼层均配有热水器、直饮水。楼内设立自习室，安排专人负责管理。小学部每间宿舍住4人，最多容纳64人住校，配备独立卫浴，书桌衣柜等一应俱全。',
	'校车':'校车',
	'校车_com':'学校运营7条校车线路，覆盖通州区主要生活区，校车采取标准校车规格，安全便捷保障学生上下学乘车需求。',
	// 招生
	'报名截止':'报名截止',
	'申请探校':'申请探校',
	'预约探校':'预约探校',
	'学校收费标准':'学校收费标准',
	'学年':'学年',
	'查看退费政策':'查看退费政策',
	'总计：':'总计：',
	'咨询优惠政策':'咨询优惠政策',
	'学费':'学费',
	'就一餐':'就一餐',
	'就二餐（早餐+午餐）':'就二餐（早餐+午餐）',
	'就二餐（午餐+晚餐）':'就二餐（午餐+晚餐）',
	'就三餐':'就三餐',
	'就一餐（午餐及两点）':'就一餐（午餐及两点）',
	'就二餐（早餐+午餐及两点）':'就二餐（早餐+午餐及两点）',
	'就二餐（午餐+晚餐及两点）':'就二餐（午餐+晚餐及两点）',
	'就三餐（三餐及两点）':'就三餐（三餐及两点）',
	'就四餐（两点）':'就四餐（两点）',
	'餐费':'餐费',
	'平日住宿费':'平日住宿费',
	'生活管理费':'生活管理费',
	'住宿费':'住宿费',
	'A档0至5公里（含）':'A档0至5公里（含）',
	'B档6至10公里（含）':'B档6至10公里（含）',
	'C档11至15公里（含）':'C档11至15公里（含）',
	'校车费':'校车费',
	'教材费':'教材费',
	'国际班':'国际班',
	'多语种班':'多语种班',
	'体育特长班':'体育特长班',
	'注册费':'注册费',
	'国际班注册费':'国际班注册费',
	// 教师团队
	'教师团队':'教师团队',
	'采用国际文凭项目方法论，构建六阶段探究闭环':'采用国际文凭项目方法论，构建六阶段探究闭环',
	'每学期开展2个跨学科主题项目（如「城市生态实验室」「文化遗产守护者」）':'每学期开展2个跨学科主题项目（如「城市生态实验室」「文化遗产守护者」）',
	// 招生咨询
	'请输入您的学生信息，我们的教师团队将尽快与您联系':'请输入您的学生信息，我们的教师团队将尽快与您联系',
	'学生姓名':'学生姓名',
	'请输入学生姓名':'请输入学生姓名',
	'联系电话':'联系电话',
	'请输入您的联系电话':'请输入您的联系电话',
	'基本情况':'基本情况',
	'请输入学生基本情况':'请输入学生基本情况',
	'立即咨询':'立即咨询',
	'咨询信息已提交等待回复':'咨询信息已提交等待回复',
	// 退费政策
	'tuifeizhengce_title':'北京中加学校、北京通州华仁学校退费管理办法',
	'tuifeizhengce_1':'（一）学费的退费管理办法',
	'tuifeizhengce_1_1':'(1)学生家长需书面提出退学退费申请，并在学校有关部门办理完退学手续和学籍转出手续后方可办理退费事宜;',
	'tuifeizhengce_1_2':'(2)在第一学期开学前提出申请的可退还已交全年学费，',
	'tuifeizhengce_1_3':'(3)在第一学期开学一个月内提出申请可退还已交全年学费的 80%;',
	'tuifeizhengce_1_4':'(4)在第一学期开学二个月内提出申请可退还已交全年学费的 60%;',
	'tuifeizhengce_1_5':'(5)在第一学期开学二个月后提出申请的则不退第一学期的学费，',
	'tuifeizhengce_1_6':'(6)在第一学期结束后提出申请退第二学期学费的，参照以上第一学期的退费办法执行;',
	'tuifeizhengce_1_7':'(7)在第二学期开学二个月后提出申请的不可退费。',
	'tuifeizhengce_2':'（二）住宿费、餐费的退费管理办法',
	'tuifeizhengce_2_1':'(1)开学入住后因个人原因提出不住宿的，扣除实际入住费用后办理退费',
	'tuifeizhengce_2_2':'(2)学生预缴餐费后，因故没有就餐。在学生家长和学校相关部门核对就餐天数无误后根据未就餐次数和对应餐标核算后办理餐费退费',
	'tuifeizhengce_3':'（三）其他',
	'tuifeizhengce_3_1':'未交齐学费的，不退任何费用:',
	'tuifeizhengce_3_2':'退费时需先查看交费情况，个人交纳的退费给个人，公司交纳的退费给公司。',
	'tuifeizhengce_3_3':'监督电话:62512345、12315',
	// 北京中加学校
	'zhongjiaxuexiao_wenzimiaoshi':'北京中加学校（BCCSC），始建于1997年，\n是北京第一所中外合作办学学校。\n学校引入加拿大优质省级公立教育体系与私立教育资源，\n致力于构建共融世界的教育平台，\n培养对接全球知识视野、代表东方文化力量的国际高中生。',
	'北京':'北京',
	'香港':'香港',
	'新加坡':'新加坡',
	'悉尼':'悉尼',
	'伦敦':'伦敦',
	'纽约':'纽约',
	'多伦多':'多伦多',
	'洛杉矶':'洛杉矶',
	'年':'年',
	'留学目的地':'留学目的地',
	'毕业生':'毕业生',
	'zhongjiaxuexiao_wenzimiaoshi1':'学校以伙伴方式，着力发展师资团队与家庭社群，\n近三十年的持续累积与文化输出，\n让中加社区的18000+孩子，\n面向世界跨越成长。',
	'亲爱的同学们、家长朋友们：':'亲爱的同学们、家长朋友们：',
	'大家好！':'大家好！',
	'principal1':'岁月不辍，华章日新。在国际化、全球化、多元化与智能化交融的今天，我始终坚信，教育是唤醒心灵、点燃未来的火种。中加学校通过国际教育资源本土化融合的路径，构建了完善的国际化人才培养的课程体系，实现了“双语双文化、双轨双平台”育人模式。在中加的学习不仅是知识的传递与技能培养，更是批判性思维、创造力与社会责任感的培育。',
	'principal2':'教育是一场温暖的修行。而你们，正是这场修行中最亮丽的风景。希望我们一起启航梦想，在开放的环境中探索，在跨文化交流中合作，在追求卓越时关怀他人。无论未来走向世界哪个角落，用行动诠释“中国心，世界人”的担当。',
	'principal3':'教育是传承，是创新的使命。五千年中华文明，是我们的精神源泉，新时代、新中加更赋予我们继往开来的重任。我们全体教师会以爱为底色，用尊重与信任发现每个学生的闪光点，用耐心与智慧理解每一个独特的灵魂，让教育真正成为影响生命的温暖旅程。',
	'principal4':'我们将守正创新，固本清源，培养创新型、应用型、复合型人才。愿你们心怀家国天下，做文明传承的接力者，与时俱进，以开放包容的胸怀拥抱世界。愿中加成为滋养人才的沃土，愿每一位中加学子都能以自信的姿态拥抱世界，书写人类共同的未来！',
	// 北京通州华仁学校
	'tongzhouhuaren_message1':'北京通州华仁学校（BCS），创立于2013年，\n是北京中加学校在基础教育领域的拓展与延伸，\n两校一园达成全学段课程服务目标。',
	'tongzhouhuaren_message2':'学校以国家课程标准主导建设主线课程，\n增强课程融合理念，\n扩展教学空间的深度和宽度。\n使学校成为一所服务城市副中心，\n集小学、初中、高中一贯制、\n中外籍学生同校就读的寄宿兼走读制学校。',
	'tongzhouhuaren_message3':'教育的意义是点燃。我们相信每个灵魂都是独特的星河，不应该用统一标尺来预测其轨迹。我们应该以虔诚之心，发现他的光芒，唤醒他内在的潜能，激发他改变世界的勇气。',
	'tongzhouhuaren_message4':'Education is about igniting potential‌. We believe every child is a universe of possibilities - too vast to be confined by standardized measures.',
	'tongzhouhuaren_message5':'Through thoughtful guidance, we help the students to:',
	'tongzhouhuaren_message6':'• Discover their unique brilliance',
	'tongzhouhuaren_message7':'• Develop their hidden streng',
	'tongzhouhuaren_message8':'• Build the confidence to make a difference',
	'校长寄语':'校长寄语',
	'田振周':'田振周',
	'校长':'执行校长',
	'姜天':'姜天',
	'执行校长':'执行校长',
	'常务副校长':'常务副校长',
	'小学部':'小学部',
	'初中部':'初中部',
	...zhLocale
}
export default cn;


// WEBPACK FOOTER //
// ./src/utils/i18n/langs/cn.js